exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CheckpointInfo-module__wrapper___2UDVd{display:grid;gap:.75rem;justify-items:start;grid-template-columns:auto 1fr}.CheckpointInfo-module__wrapper___2UDVd p{color:#b4bac3;font-size:14px}.CheckpointInfo-module__wrapper___2UDVd .CheckpointInfo-module__token___3jr5J img{width:40px}", ""]);

// exports
exports.locals = {
	"wrapper": "CheckpointInfo-module__wrapper___2UDVd",
	"token": "CheckpointInfo-module__token___3jr5J"
};